export const COMPANY_CONFIGS = {
    americanexpress: {
        name: 'American Express',
        logo: '/images/companies/americanexpress.jpg',
        bannerImage: '/images/AMEX-banner.webp',
        primaryColor: '#006FCF',
        secondaryColor: '#0077BE',
        // favicon: '/images/companies/amex-favicon.ico'
    },
    default: {
        name: 'VillaTracker',
        logo: '/images/villatracker-logo.png',
        primaryColor: '#284866',
        secondaryColor: '#165093',
        // favicon: '/favicon.ico'
    }
};